module.exports = __webpack_public_path__ + "static/bmx-rider-mobile-dab0acf0d41caed4c3d8c75af5f31efb.png";